import "./polyfills.js";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./i18n";
import "./styles/global.css";
import App from "./App.jsx";
import CookieConsentRoot from "./CookieConsentRoot.jsx";
import { readConsent } from "./utils/consent.js";
import { applyConsent, initTagManager } from "./utils/tagManager.js";

// Before the first render, so a returning visitor's stored decision reaches
// the container ahead of the first page_view rather than one React root
// later. Both calls are no-ops during the prerender (no VITE_GTM_ID needed
// to reason about it — scripts/prerender.js sets window.__TL_PRERENDER__
// before any page script runs) and when no decision has been stored yet,
// in which case index.html's denied defaults simply stand.
initTagManager();
const storedConsent = readConsent();
if (storedConsent) applyConsent(storedConsent);

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// `npm run dev` serves the bare Vite shell — an empty #root, since only the
// production build's prerender step (scripts/prerender.js) ever populates
// it — so hydrateRoot() there has nothing real to reconcile against and
// always logs a hydration-mismatch error, on every single route, that
// doesn't reflect anything wrong with the app. createRoot() is the correct
// call for an empty container; hydrateRoot() only makes sense once
// prerendering has actually put matching markup there.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

ReactDOM.createRoot(document.getElementById("cookie-consent-root")).render(
  <React.StrictMode>
    <CookieConsentRoot />
  </React.StrictMode>
);
